export class Config {
  static delayOpenMenu: number = 100;
  static delayCloseMenu: number = 200;
}
